import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["from", "to"]

  connect() {
    this.updateConstraints()
  }

  updateConstraints() {
    const fromValue = this.fromTarget.value
    const toValue = this.toTarget.value

    // Constrain "to" so it can't be before "from", but never loosen
    // below the global min set by the component
    if (fromValue) {
      const globalMin = this.toTarget.getAttribute("data-global-min")
      this.toTarget.min = globalMin && globalMin > fromValue ? globalMin : fromValue
    }

    // Constrain "from" so it can't be after "to", but never loosen
    // above the global max set by the component
    if (toValue) {
      const globalMax = this.fromTarget.getAttribute("data-global-max")
      this.fromTarget.max = globalMax && globalMax < toValue ? globalMax : toValue
    }
  }
}
